<template>
  <div class="filter-container">
    <fa icon="filter" class="icons" @click="toggleSideMenu"></fa>
    <transition name="side-nav-transition">
      <div class="side-nav-menu" :class="{'visible': showFilters}">
        <div class="logo">
          <img src="img/software-logo.png" alt="Logo">
        </div>
        <div class="menu-items is-flex is-flex-direction-column is-justify-content-center is-align-items-center">
          <div v-for="(item, index) in items" class="menu-item" :key="index">
            <div @click="expandSubitems(index)">
              {{ item.title }}
              <fa :icon="getIconForMenuItem(item.expanded)"></fa>
            </div>
            <transition name="subitems-transition">
              <ul v-if="item.expanded">
                <li v-for="subitem in item.subitems" :key="subitem.title">{{ subitem.title }}</li>
              </ul>
            </transition>
          </div>
        </div>
        <fa icon="xmark" class="icons close-icon" @click="toggleSideMenu"></fa>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'filter-container',
  computed: {
    deviceIsMobile() {
      return this.$store.state.device.type === 'mobile';
    },
  },
  data() {
    return {
      showFilters: false,
      items: [
        {title: 'Item 1', subitems: [{title: 'Subitem 1'}, {title: 'Subitem 2'}], expanded: false},
        {title: 'Item 2', subitems: [{title: 'Subitem 3'}, {title: 'Subitem 4'}], expanded: false},
        {title: 'Item 3', subitems: [{title: 'Subitem 5'}, {title: 'Subitem 6'}], expanded: false},
        {title: 'Item 4', subitems: [{title: 'Subitem 7'}, {title: 'Subitem 8'}], expanded: false},
      ]
    }
  },
  methods: {
    toggleSideMenu() {
      this.showFilters = !this.showFilters;
    },
    expandSubitems(index) {
      this.items[index].expanded = !this.items[index].expanded
    },
    getIconForMenuItem(expanded) {
      return expanded ? 'chevron-down' : 'chevron-right';
    },
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  .icons {
    align-self: flex-start;
    justify-self: flex-end;
    font-size: 1.7em;
    color: $primary-font-color;
    background-color: #0a4695;
    margin: 10px;
    z-index: 100;
    cursor: pointer;
  }

  .close-icon {
    position: absolute;
    top: 5px;
    right: 10px;
  }

  .side-nav-menu {
    display: flex;
    flex-direction: column;
    background-color: $primary;
    z-index: 99;
    position: fixed;
    top: 0;
    left: -350px;
    bottom: 0;
    padding: 20px;
    width: 100%;
    max-width: 350px;
    transition: left 0.3s ease;

    .logo {
      width: 100%;
      text-align: center;
      padding: 5px 0;
      font-size: 1.5em;
      font-weight: bold;
      color: $primary-font-color;
      margin-bottom: 20px;
    }

    .menu-items {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      gap: 1em;
      width: 100%;
      text-align: center;

      .menu-item {
        width: 100%;
        color: $primary-font-color;
        font-size: 1.2em;
        font-weight: bold;
        cursor: pointer;

        &:hover {
          color: lighten($primary-font-color, 20%);
        }

        & > div {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        ul {
          list-style-type: none;
          padding: 0;
          margin: 0;
          text-align: left;

          li {
            margin: 0.5em 0;
          }
        }
      }
    }
  }

  .visible {
    left: 0 !important;
  }
}

@media screen and (max-width: 768px) {
  .filter-container {
    .side-nav-menu {
      left: -100%;
      width: 100%;
      max-width: 100%;
    }
  }
}

.side-nav-transition-enter-active,
.side-nav-transition-leave-active {
  transition: all 0.3s ease;
}

.side-nav-transition-enter,
.side-nav-transition-leave-to {
  transform: translateY(-100%);
}

.side-nav-transition-enter-to,
.side-nav-transition-leave {
  transform: translateY(0);
}

.subitems-transition-enter-active,
.subitems-transition-leave-active {
  transition: all 0.3s ease;
}

.subitems-transition-enter,
.subitems-transition-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.subitems-transition-enter-to,
.subitems-transition-leave {
  transform: translateY(0);
  opacity: 1;
}
</style>